// extracted by mini-css-extract-plugin
module.exports = {"title":"CountsCard_title__lSjy4"};